import Crud from "../Crud";
import MUICyanColor from "@mui/material/colors/cyan";

/**
 * Static helper functions related to Regions.
 */
export default class Region extends Crud {

    /**
     * @param {object} region The region object.
     * @returns The display name of the region.
     */
    static getDisplayName(region) {
        return region.name;
    }

    /**
     * Determines if a region matches a search query.
     *
     * @param {object} region The region to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the region matches the query.
     */
    static match(region, query) {
        return (
            (region.name !== null && region.name.toLowerCase().includes(query)) ||
            region.id === +query
        );
    }

    /**
     * @param {array} regions The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(regions) {
        return regions.sort((a, b) => {
            return (a.name).localeCompare(b.name);
        });
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        return MUICyanColor;
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "Public";
    }
}